import React, { useEffect, useMemo, useRef, useState } from "react";
import { X, Send, User, ClipboardList, FileText } from "lucide-react";
import {
  Form,
  Input,
  InputNumber,
  Select,
  message,
  Button,
  Upload,
  ConfigProvider,
} from "antd";
import surgeryIcon from "../../assets/surgeryinewcon.svg";
import moment from "moment";
import { DatePicker } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import stateDataJson from "../../assets/state.json";
const SectionTitle = ({ icon: Icon, title }) => (
  <div className="flex items-center gap-2 pt-2 pb-3 border-b border-gray-100 mb-4">
    <span className="w-8 h-8 rounded-lg bg-[#E8F6F4] flex items-center justify-center flex-shrink-0">
      <Icon className="w-4 h-4 text-[#0D6B6E]" />
    </span>
    <h3 className="text-sm font-bold text-gray-800 mb-0 uppercase tracking-wide">
      {title}
    </h3>
  </div>
);

const formItemClass = "mb-0 surgery-form-item";

export default function Surgery({
  isOpen,
  onClose,
  patientId,
  appointmentId = "",
  doctorName = "",
}) {
 
  const API_URL = process.env.REACT_APP_API_URL;
  const { RangePicker } = DatePicker;
  const [form] = Form.useForm(); // Add form instance
  const selectedStateCode = Form.useWatch("state", form);
  const selectedCityName = Form.useWatch("city", form);
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hospitalizationData, setHospitalizationData] = useState([]);
  const [hospitalizationtype, setHospitalizationType] = useState();
  const [serviceTypenew, setServiceType] = useState();
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [prescription, setselectedprescription] = useState("");
  const [idProof, setselectedidproof] = useState("");
  const [selectedreport, setSelectedReport] = useState("");
  const [selectedIdreport, setSelctedIdReport] = useState("");
  const [idProoftype, setselectedidprooftype] = useState("");
  const [medicalReportType, setmedicalReportType] = useState("");
  const [patientDetails, setPatientDetails] = useState({});
  const [pincode, setPincode] = useState("");
  const [fetchedState, setFetchedState] = useState("");
  const [fetchedCity, setFetchedCity] = useState("");
  const [areaOptions, setAreaOptions] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const DEFAULT_COUNTRY = "INDIA";
  const [saveLoading, setSaveLoading] = useState(false);
  const lastFetchedCityStateRef = useRef("");
  const stateOptions = useMemo(
    () =>
      (stateDataJson?.stateData || []).map((s) => ({
        value: s.code,
        label: s.name,
      })),
    []
  );

  const resolveStateCode = (stateValue) => {
    if (!stateValue) return "";
    const normalized = String(stateValue).trim();
    const match = stateOptions.find(
      (s) =>
        s.value.toLowerCase() === normalized.toLowerCase() ||
        s.label.toLowerCase() === normalized.toLowerCase()
    );
    return match?.value || normalized;
  };

  const fetchCitiesByStateCode = async (stateCode, preferredCity = "") => {
    const resolvedCode = resolveStateCode(stateCode);
    if (!resolvedCode) {
      lastFetchedCityStateRef.current = "";
      setAreaOptions([]);
      setHospitals([]);
      form.setFieldsValue({ hospital: [] });
      form.setFieldsValue({ city: undefined });
      return;
    }

    // Prevent repeated calls for the same state (fixes request loop).
    if (lastFetchedCityStateRef.current === resolvedCode) {
      return;
    }
    lastFetchedCityStateRef.current = resolvedCode;

    try {
      setCityLoading(true);
      const accessToken = localStorage.getItem("access_token_che");
      const response = await fetch(
        `${process.env.REACT_APP_ENGAGE_URL}getStateMaster/list/City?stateCode=${encodeURIComponent(
          resolvedCode
        )}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          },
        }
      );
      const data = await response.json();
      const cities = Array.isArray(data?.data) ? data.data : [];
      const cityOptions = cities.map((city) => ({
        value: city,
        label: city,
        key: city,
      }));
      setAreaOptions(cityOptions);
      setHospitals([]);
      form.setFieldsValue({ hospital: [] });

      const preferred = String(preferredCity || "").trim();
      const matchedCity = preferred
        ? cities.find((city) => city.toLowerCase() === preferred.toLowerCase())
        : "";
      form.setFieldsValue({ city: matchedCity || undefined });
      if (matchedCity) {
        getHospitalByCity(matchedCity);
      }
    } catch (error) {
      console.error("Error fetching cities by state:", error);
      setAreaOptions([]);
      lastFetchedCityStateRef.current = "";
    } finally {
      setCityLoading(false);
    }
  };

  useEffect(() => {
   
    
    if (patientId) {
      fetchpatient();
    }
  }, [patientId, form]);
  console.log(patientDetails, "patientDetails");



 const fetchpatient = async () => {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const response = await axios.get(
          `${API_URL}patient/search?patientId=${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        console.log(response.data, "zsxdcfvghbjcfvgbh");
        const firstPatient = response?.data.data[0];
        console.log(firstPatient, "dfghjk");
        setPatientDetails(firstPatient);

        // Populate form with patient data
        if (firstPatient) {
          form.setFieldsValue({
            firstName: `${firstPatient.firstName || ""} ${
              firstPatient.lastName || ""
            }`.trim(),
            dob: firstPatient.dob ? moment(firstPatient.dob) : null,
            mobile: firstPatient.mobileNumber,
            address1: firstPatient.address,
            // Add more fields as they become available in your form
          });
          
          // Set pincode in state if available
          if (firstPatient.pinCode || firstPatient.pincode) {
            setPincode(firstPatient.pinCode || firstPatient.pincode);
          }
        }
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    };
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
    setPincode(value);
    console.log("Pincode changed to:", value);
    
    // Validate and call API when pincode is 6 digits
    if (value.length === 6) {
      console.log("Pincode is 6 digits, calling API for:", value);
      fetchState(value);
    }
  };
  
    const fetchState = async (pincode) => {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const response = await axios.get(
         `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
                console.log(response.data.data, "zsxdcfvghbjcfvgbh");
        
        // Extract unique state and create area options from the response
        if (response.data.data && response.data.data.length > 0) {
          const addressData = response.data.data[0]; // Take first entry since all have same state
          
          const stateCode = resolveStateCode(addressData.state || "");
          form.setFieldsValue({ state: stateCode });
          setFetchedState(addressData.state || "");
          setFetchedCity(addressData.area || "");
          lastFetchedCityStateRef.current = "";
          await fetchCitiesByStateCode(stateCode, addressData.area || "");
        }
        
        } catch (error) {
          console.error("Error fetching address details:", error);
        }
    };

    useEffect(() => {
      if (patientId) {
        fetchpatient();
      }
    }, [patientId]);

  const changeHandler = async (info) => {
    const name = info.file.name;
    const fileType = name.split(".").pop().toLowerCase();
    setSelectedReport(name);
    setmedicalReportType(fileType);
    console.log(info, "infio");
    let b64File = await encodeBase64File(info.file.originFileObj);
    setselectedprescription(b64File);
    console.log(b64File, "infi");

    // Trigger form validation for the upload field
    form.validateFields(["uploadFile"]);
  };

  const changeHandlernew = async (info) => {
    console.log(info, "rghj");
    const name = info.file.name;
    const fileType = name.split(".").pop().toLowerCase();
    setSelctedIdReport(name);
    setselectedidprooftype(fileType);
    let b64File = await encodeBase64Filenew(info.file.originFileObj);
    setselectedidproof(b64File);

    // Trigger form validation for the upload field
    form.validateFields(["idproof"]);
  };

  const encodeBase64File = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL.split(",")[1]);
      };
      console.log(fileInfo);
    });
  };

  const encodeBase64Filenew = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL.split(",")[1]);
      };
      console.log(fileInfo);
    });
  };

  const getHospitalByCity = async (cityName) => {
    if (!cityName) {
      setHospitals([]);
      form.setFieldsValue({ hospital: [] });
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      const stateCode = form.getFieldValue("state");
      const payload = {
        city: cityName,
        ...(stateCode ? { stateCode } : {}),
      };
      const response = await fetch(
        `${process.env.REACT_APP_SURGERY_STATUS}dropdown/surgeryHospital/list`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      
          console.log(data.successObject, "list");
      setHospitals(data.successObject);
      form.setFieldsValue({ hospital: [] });
    } catch (error) {
      console.error("Error fetching hospitals:", error);
      setHospitals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(serviceTypenew, hospitalizationtype, "cfghjkvghj");
    if (serviceTypenew && hospitalizationtype) {
      fetchData();
    }
  }, [serviceTypenew, hospitalizationtype]);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_NEWBASEURL}hospitalizationServiceType/list/filter?serviceTypeId=${serviceTypenew}&hospitalizationTypeId=${hospitalizationtype}&status=1`
      );
      const data = await response.json();
      console.log(data, "edrftyguhjgyhu");
      if (data.status == 200) {
        setHospitalizationData(data.data);
      } else {
        setHospitalizationData([]);
      }
    } catch (error) {
      console.error("Error fetching hospitalization data:", error);
    }
  };
  useEffect(() => {
    if (!isOpen) {
      setHospitals([]);
      form.setFieldsValue({ hospital: [] });
    }
  }, [isOpen, form]);

  const renderHospitalizationOptions = () => {
    if (serviceTypenew === 8) {
      return (
        <>
          <Select.Option value={10}>Opthalmology</Select.Option>
          <Select.Option value={8}>Gynecology</Select.Option>
          <Select.Option value={1}>General Surgery</Select.Option>
          <Select.Option value={5}>Urology</Select.Option>
          <Select.Option value={7}>ENT</Select.Option>
          <Select.Option value={4}>Orthopedic</Select.Option>
          <Select.Option value={2}>Oncology</Select.Option>
          <Select.Option value={6}>Cardiology</Select.Option>
          <Select.Option value={3}>Neurology</Select.Option>
          <Select.Option value={15}>Nephrology</Select.Option>
          <Select.Option value={11}>General Medicine</Select.Option>
          <Select.Option value={9}>Gastrologic</Select.Option>
        </>
      );
    } else if (serviceTypenew === 9) {
      return (
        <>
          <Select.Option value={12}>OPD Others</Select.Option>
        </>
      );
    } else if (serviceTypenew === 10) {
      return (
        <>
          <Select.Option value={13}>Investigation Others</Select.Option>
        </>
      );
    } else if (serviceTypenew === 11) {
      return (
        <>
          <Select.Option value={14}>Day Care Others</Select.Option>
        </>
      );
    } else if (serviceTypenew === 12) {
      return (
        <>
          <Select.Option value={10}>Opthalmology</Select.Option>
          <Select.Option value={8}>Gynecology</Select.Option>
          <Select.Option value={1}>General Surgery</Select.Option>
          <Select.Option value={5}>Urology</Select.Option>
          <Select.Option value={7}>ENT</Select.Option>
          <Select.Option value={4}>Orthopedic</Select.Option>
          <Select.Option value={2}>Oncology</Select.Option>
          <Select.Option value={6}>Cardiology</Select.Option>
          <Select.Option value={3}>Neurology</Select.Option>
          <Select.Option value={15}>Nephrology</Select.Option>
          <Select.Option value={11}>General Medicine</Select.Option>
          <Select.Option value={9}>Gastrologic</Select.Option>
        </>
      );
    } else {
      return null;
    }
  };

  const handleServiceTypeChange = (value) => {
    console.log("Selected service type:", value);
    setServiceType(value);
    setHospitalizationType(null);

    // Reset form fields
    form.setFieldsValue({
      HospitalizationType: undefined,
      procedureName: undefined,
    });
  };

  const handleHospitalChange = (value, option) => {
    console.log("Selected hospitals:", value, option);
    
    // Handle multiple hospital selection
    if (Array.isArray(value)) {
      // Multiple hospitals selected
      const selectedHospitals = value.map((hospitalCode, index) => {
        const hospital = hospitals.find(h => h.hospitalCode === hospitalCode);
        return {
          hospitalCode: hospitalCode,
          name: hospital ? hospital.hospitalName : hospitalCode,
        };
      });
      setSelectedHospital(selectedHospitals);
    } else {
      // Single hospital selected (fallback)
      setSelectedHospital([{
        hospitalCode: value,
        name: option.label,
      }]);
    }
  };

  const handleHospitalizationTypeChange = (value) => {
    console.log("Selected hospitalization type:", value);
    setHospitalizationType(value);

    // Reset procedure name
    form.setFieldsValue({
      procedureName: undefined,
    });
  };

  const openImageInNewTab = () => {
    if (prescription && medicalReportType) {
      if (medicalReportType === "pdf") {
        const newTab = window.open();
        newTab.document.body.innerHTML = `<embed src="data:application/pdf;base64, ${prescription}" style="width:100%; height:100%;" />`;
      } else if (
        medicalReportType === "png" ||
        medicalReportType === "jpg" ||
        medicalReportType === "jpeg"
      ) {
        const newTab = window.open();
        newTab.document.body.innerHTML = `<img src="data:image/${medicalReportType};base64, ${prescription}" style="max-width:100%;" />`;
      }
    } else {
      message.error("No image available to display.");
    }
  };

  const openImageInNewTabidproof = () => {
    if (idProof && idProoftype) {
      if (idProoftype === "pdf") {
        const newTab = window.open();
        newTab.document.body.innerHTML = `<embed src="data:application/pdf;base64, ${idProof}" style="width:100%; height:100%;" />`;
      } else if (
        idProoftype === "png" ||
        idProoftype === "jpg" ||
        idProoftype === "jpeg"
      ) {
        const newTab = window.open();
        newTab.document.body.innerHTML = `<img src="data:image/${idProoftype};base64, ${idProof}" style="max-width:100%;" />`;
      }
    } else {
      message.error("No image available to display.");
    }
  };
  const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
const handleregister = async () => {
   const tenantId = localStorage.getItem("tenantId");
  try {
    // Step 1: Patient Registration
    const token = localStorage.getItem("access_token");
    const firstName = localStorage.getItem("firstName");
      const lastName = localStorage.getItem("lastName");
      const payload = {

salutation: patientDetails.salutation,
  mobileNumber: patientDetails.mobileNumber,
  firstName: patientDetails.firstName,
  lastName: patientDetails.lastName,
  email: "",
  password: "Test@123",
  dob: formatDate(patientDetails.dob),
  gender:  patientDetails.gender == "male"
  ? "M"
  : patientDetails.gender == "female"
    ? "F"
    : "O",
  address1: patientDetails.address,
  address2: patientDetails.address,
  pincode: patientDetails.pinCode,
  city: "",
  state: patientDetails.state,
  country: "India",
  privacyPolicy: "Y",
  termsCondition: "Y",
  source: "HOSPI360",
  hospitalId: localStorage.getItem("hospitalid"),
  createdBy: firstName +" "+ lastName,
  modifiedBy: firstName +" "+ lastName,



       
      };

    const registerResponse = await fetch(`${process.env.REACT_APP_API_URL_PATIENTS}patient-user/register`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload)
    });

    console.log(registerResponse.status, "registration status");

    if (registerResponse.status === 200) {
      const registerResult = await registerResponse.json();
      console.log(registerResult, "registration response data");

      // Step 2: Update Patient with curebayPatientId
      const authToken = localStorage.getItem("auth_token");
      const updatePayload = {
        firstName: patientDetails.firstName,
        lastName: patientDetails.lastName,
        gender: patientDetails.gender,
        mobileNumber: patientDetails.mobileNumber, // Fixed: was patient.mobileNumber
        curebayPatientId: registerResult.data?.patientCode || registerResult.patientCode
      };

      const updateResponse = await fetch(`${API_URL}patient/update/${patientDetails.patientCode}`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
           tenantId: tenantId,
        },
        body: JSON.stringify(updatePayload)
      });

      if (updateResponse.ok) {
        const updateResult = await updateResponse.json();
        console.log(updateResult, "update response data");
        
        // Update local patientDetails
        patientDetails.curebayPatientId = updatePayload.curebayPatientId;
         fetchpatient();
        return {
          registration: registerResult,
          update: updateResult,
          curebayPatientId: updatePayload.curebayPatientId
        };
      } else {
        const updateError = await updateResponse.json();
        throw new Error(updateError.message || "Patient update failed");
      }
    } else {
      const registerError = await registerResponse.json();
      throw new Error(registerError.message || "Registration failed");
    }
  } catch (error) {
    console.error("Registration process error:", error);
    throw error;
  }
};

const formatDatenew = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
  const resolveHospitalsFromForm = (hospitalFieldValue) => {
    const codes = Array.isArray(hospitalFieldValue)
      ? hospitalFieldValue
      : hospitalFieldValue
      ? [hospitalFieldValue]
      : [];
    return codes.map((hospitalCode) => {
      const h = hospitals.find((x) => x.hospitalCode === hospitalCode);
      return {
        hospitalCode: String(hospitalCode),
        name: h?.hospitalName || h?.name || String(hospitalCode),
      };
    });
  };

  const handleSave = async () => {
    setSaveLoading(true); // Start loading
    
    try {
      let curebayPatientId = patientDetails.curebayPatientId;
      if (!curebayPatientId) {
        const registrationResult = await handleregister();
        curebayPatientId =
          registrationResult?.curebayPatientId || patientDetails.curebayPatientId;
      }
      const token = localStorage.getItem("access_token");
      const formValues = await form.validateFields();

      const hospitalsFromForm = resolveHospitalsFromForm(formValues.hospital);
      const firstHospitalCode = hospitalsFromForm[0]?.hospitalCode;
      const procedureId = formValues.procedureName;

      if (!curebayPatientId) {
        message.error("Patient is not registered. Please try again.");
        return;
      }
      if (!firstHospitalCode) {
        message.error("Please select at least one hospital.");
        return;
      }
      if (!procedureId) {
        message.error("Please select Hospitalization Subtype.");
        return;
      }
      if (!formValues.dateRange?.[0] || !formValues.dateRange?.[1]) {
        message.error("Please select procedure planned dates.");
        return;
      }

      const fromDate = formValues.dateRange[0].format("YYYY-MM-DD");
      const toDate = formValues.dateRange[1].format("YYYY-MM-DD");

      // Find selected hospitalization subtype details
      const selectedHospitalizationSubtype = hospitalizationData.find(
        (item) => item.hospitalizationSubTypeId === formValues.procedureName
      );

      // Get hospitalization type name
      const hospitalizationTypeNames = {
        1: "General Surgery",
        2: "Oncology",
        3: "Neurology",
        4: "Orthopedic",
        5: "Urology",
        6: "Cardiology",
        7: "ENT",
        8: "Gynecology",
        9: "Gastrologic",
        10: "Opthalmology",
        11: "General Medicine",
        12: "OPD Others",
        13: "Investigation Others",
        14: "Day Care Others",
        15: "Nephrology",
      };

      // Get service type name
      const serviceTypeNames = {
        8: "IPD",
        9: "OPD",
        10: "Investigation",
        11: "Day Care",
        12: "ICU",
      };
      const Payloadnew = [
        {
          patientId: curebayPatientId,
          procedureId,
          hospitalId: firstHospitalCode,
          fromDate,
          toDate,
        },
      ];

      const buildUploadFields = () => {
        const fields = {};
        if (prescription) {
          fields.medicalReport = prescription;
          if (medicalReportType) fields.medicalReportType = medicalReportType;
        }
        if (idProof) {
          fields.idProof = idProof;
          if (idProoftype) fields.idProofType = idProoftype;
        }
        return fields;
      };

      // Create payload for each selected hospital
      const createPayloadForHospital = (hospital) => ({
        name: patientDetails.firstName,
        dob: formatDatenew(patientDetails.dob),
        emailId: formValues.email || "",
        contactNumber: patientDetails.mobileNumber,
        patientId: curebayPatientId,
        address1: formValues.address1 || patientDetails.address || "",
        address2: formValues.address2 || "",
        city: formValues.city || "",
        state: formValues.state || "",
        country: DEFAULT_COUNTRY,
        nationality: formValues.nationality || "",
        procedureName:
          selectedHospitalizationSubtype?.hospitalizationSubType || "",
        procedureId: formValues.procedureName || 0,
        notes:
          formValues.medicalcondition || patientDetails.chiefComplaint || "",
        business: 0,
        preferredHospitalAndClinics: hospital.hospitalCode || "",
        serviceType: serviceTypenew || 0,
        serviceTypeName: serviceTypeNames[serviceTypenew] || "",
        hospitalId: hospital.hospitalCode || "",
        hospitalName: hospital.name || "",
        status: 11,
        createdBy: "",
        modifiedBy: "",
        disableStatus: "N",
        activeServiceStatus: "N",
        ...buildUploadFields(),
        procedurePlannedStartDate:
          formValues.dateRange?.[0]?.format("YYYY-MM-DD HH:mm:ss") || "",
        procedurePlannedEndDate:
          formValues.dateRange?.[1]?.format("YYYY-MM-DD HH:mm:ss") || "",
        procedurePlannedDate: "",
        sourceChannel: "HOSPITAL360",
        serviceSubType:
          formValues.servicesubType === 1
            ? "Emergency"
            : formValues.servicesubType === 2
            ? "Non-Emergency"
            : formValues.servicesubType === 3
            ? "Others"
            : "",
        serviceSubTypeId: formValues.servicesubType || 0,
        hospitalizationType:
          hospitalizationTypeNames[hospitalizationtype] || "",
        hospitalizationTypeId: hospitalizationtype || 0,
        CHEId: "CENTRALCLINIC",
        CHELocationId: "LOC_CENTRALECLINIC",
      });

      const payload =
        hospitalsFromForm.length > 0
          ? hospitalsFromForm.map((hospital) => createPayloadForHospital(hospital))
          : [createPayloadForHospital({ hospitalCode: firstHospitalCode, name: "" })];

      console.log("Validation payload:", Payloadnew);
      console.log("Submit payload:", payload);

      // const postResponse = await post(`${process.env.REACT_APP_NEWBASEURL}PatientServiceEnquiryFormValidation/`,

      //       Payloadnew
      //     );
      const postResponse = await axios.post(
        `${process.env.REACT_APP_NEWBASEURL}PatientServiceEnquiryFormValidation/`,
        Payloadnew
      );
      const validationResult = postResponse.data?.[0];
      if (validationResult?.message === "No Patient service enquiry") {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL_PATIENTS}PatientServiceEnquiryForm/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();
        console.log(result.data, "resulthjbkjnlkm");
        if (result.status==200) {
          
          handleProceed(result.data?.id);
          onClose();
        } else {
          message.error("Failed to submit surgery details");
        }
      } else {
        toast.error(
          validationResult?.message ||
            "Validation failed. Check hospital, procedure, and dates."
        );
      }
    } catch (error) {
      console.error("Error submitting surgery data:", error);
      message.error("Error submitting surgery data");
    } finally {
      setSaveLoading(false); // Stop loading regardless of success/failure
    }
  };

  if (!isOpen) return null;

  const handleProceed = async (enquiryId) => {
    console.log(enquiryId, "enquiryId");
    const formValues = form.getFieldsValue();
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    const hospitalId = localStorage.getItem("hospitalid") || "";
    const selectedHospitalizationSubtype = hospitalizationData.find(
      (item) => item.hospitalizationSubTypeId === formValues.procedureName
    );

    // Get hospitalization type name
    const hospitalizationTypeNames = {
      1: "General Surgery",
      2: "Oncology",
      3: "Neurology",
      4: "Orthopedic",
      5: "Urology",
      6: "Cardiology",
      7: "ENT",
      8: "Gynecology",
      9: "Gastrologic",
      10: "Opthalmology",
      11: "General Medicine",
      12: "OPD Others",
      13: "Investigation Others",
      14: "Day Care Others",
      15: "Nephrology",
    };

    // Get service type name
    const serviceTypeNames = {
      8: "IPD",
      9: "OPD",
      10: "Investigation",
      11: "Day Care",
      12: "ICU",
    };
    const hospitalsForProceed = resolveHospitalsFromForm(formValues.hospital);
    const payload = {
      clinicId: clinicId,
      // appointmentObjectId: selectedPatient?.id,
      // patientPrescriptionObjectId: selectedPatient?.id || null,
      patientName: `${patientDetails.firstName || ""} ${
        patientDetails.lastName || ""
      }`.trim(),
      orderPlacedTo: "SMART_CLINIC",
      patientMobileNo: parseInt(patientDetails.mobileNumber || 0),
      // txnId: "",
      // appointmentId: selectedPatient?.appointmentId || null,
      patientId: patientDetails.patientCode || patientId,
      address: formValues.address1 || patientDetails.address || "",
      patientAge: patientDetails.age || null,

      surgeryRecommendationList: hospitalsForProceed.length > 0 
        ? hospitalsForProceed.map(hospital => ({
            serviceType: serviceTypenew || 0,
            serviceTypeName: serviceTypeNames[serviceTypenew] || "",
            hospitalId: hospital.hospitalCode || "",
            hospitalName: hospital.name || "",
            serviceSubType:
              formValues.servicesubType === 1
                ? "Emergency"
                : formValues.servicesubType === 2
                ? "Non-Emergency"
                : formValues.servicesubType === 3
                ? "Others"
                : "",
            serviceSubTypeId: formValues.servicesubType || 0,
            hospitalizationType:
              hospitalizationTypeNames[hospitalizationtype] || "",
            hospitalizationTypeId: hospitalizationtype || 0,
            procedureName:
              selectedHospitalizationSubtype?.hospitalizationSubType || "",
            procedureId: formValues.procedureName || 0,
            procedurePlannedStartDate:
              formValues.dateRange?.[0]?.format("YYYY-MM-DD HH:mm:ss") || "",
            procedurePlannedEndDate:
              formValues.dateRange?.[1]?.format("YYYY-MM-DD HH:mm:ss") || "",
              surgeryEnquiryId: enquiryId || "",
          }))
        : [{
            serviceType: serviceTypenew || 0,
            serviceTypeName: serviceTypeNames[serviceTypenew] || "",
            hospitalId: "",
            hospitalName: "",
            serviceSubType:
              formValues.servicesubType === 1
                ? "Emergency"
                : formValues.servicesubType === 2
                ? "Non-Emergency"
                : formValues.servicesubType === 3
                ? "Others"
                : "",
            serviceSubTypeId: formValues.servicesubType || 0,
            hospitalizationType:
              hospitalizationTypeNames[hospitalizationtype] || "",
            hospitalizationTypeId: hospitalizationtype || 0,
            procedureName:
              selectedHospitalizationSubtype?.hospitalizationSubType || "",
            procedureId: formValues.procedureName || 0,
            procedurePlannedStartDate:
              formValues.dateRange?.[0]?.format("YYYY-MM-DD HH:mm:ss") || "",
            procedurePlannedEndDate:
              formValues.dateRange?.[1]?.format("YYYY-MM-DD HH:mm:ss") || "",
            
            
          }],
      appoimentDetails: [],
      amount: 0,
      discountedAmount: 0,
      // address: fullAddress || "",
      enquiryTickets: null,
    };
    console.log("Selected hospitals:", selectedHospital);
    console.log("Surgery recommendation list length:", payload.surgeryRecommendationList.length);
    console.log("Surgery recommendation list:", payload.surgeryRecommendationList);
    console.log(payload, "payloaddata");

    try {
 
      
      const response = await fetch(`${API_URL}orders/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });
      
      console.log("Response status:", response.status);

      const result = await response.json();
      console.log(result, "result");
      if (result.status === 200) {
        const ticketPayload = {
          patientDetails: {
            patientId: patientDetails.patientCode || patientId,
            medicaseId: "",
            patientName: `${patientDetails.firstName || ""} ${
              patientDetails.lastName || ""
            }`.trim(),
            dob: patientDetails.dob
              ? moment(patientDetails.dob).format("YYYY-MM-DD")
              : "",
            gender: patientDetails.gender || "",
            mobileNumber: patientDetails.mobileNumber || "",
            email: formValues.email || "",
            escallationNumber: "",
            address: formValues.address1 || patientDetails.address || null,
            pincode:
              pincode ||
              patientDetails.pinCode ||
              patientDetails.pincode ||
              "",
          },
          serviceDetailsMessage: "",
          tickeType: "SURGERY",
          ticketSource: "HOSPITAL360",
          hospitalId,
        };

        try {
          const ticketRes = await fetch(
            `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
        
              },
              body: JSON.stringify(ticketPayload),
            }
          );
          const ticketData = await ticketRes.json();

          if (ticketRes.ok && ticketData.status === 200) {
            const orderId = result.data?.id;
            const ticketId = ticketData.data?.id;

            if (orderId && ticketId) {
              await fetch(
                `${API_URL}createenquiry/order?orderId=${orderId}`,
                {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    tenantId: tenantId,
                  },
                  body: JSON.stringify({
                    ticketId: ticketId,
                    ticketStatus: "INPROGRESS",
                  }),
                }
              );
            }
          } else {
            console.error(
              "Command center ticket creation failed:",
              ticketRes.status,
              ticketData?.message || ticketData
            );
          }
        } catch (ticketError) {
          console.error("Error creating command center ticket:", ticketError);
        }

        toast.success("Surgery details submitted successfully!");
        onClose();
      } else {
        toast.error(result.message || "Surgery details submission failed");
      }
    } catch (error) {
      toast.error("Something went wrong while submitting surgery details");
    }
  };

  const patientFullName = `${patientDetails.firstName || ""} ${
    patientDetails.lastName || ""
  }`.trim();
  const patientAge = patientDetails.dob
    ? moment().diff(moment(patientDetails.dob), "years")
    : null;
  const patientInitials = patientFullName
    ? patientFullName
        .split(" ")
        .filter(Boolean)
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "—";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3 sm:p-4">
      <div className="bg-white rounded-2xl w-full max-w-4xl shadow-2xl flex flex-col max-h-[92vh] overflow-hidden">
        <div className="bg-gradient-to-r from-[#004172] to-[#3cba84] px-5 py-4 flex items-start justify-between gap-4 flex-shrink-0">
          <div className="flex items-start gap-3 min-w-0">
            <span className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
              <img src={surgeryIcon} alt="" className="w-6 h-6 object-contain" />
            </span>
            <div className="min-w-0">
              <h2 className="text-xl font-bold text-white mb-0.5">Surgery Enquiry</h2>
              <p className="text-white/85 text-sm mb-0">
                Submit a surgery referral for the selected patient
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 rounded-lg border border-white/40 flex items-center justify-center hover:bg-white/10 flex-shrink-0"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        <div
          className="px-5 py-3 flex flex-wrap items-center gap-4 flex-shrink-0 border-b border-[#C5E8E3]"
          style={{ background: "linear-gradient(90deg, #E8F6F4 0%, #FFFFFF 100%)" }}
        >
          <div className="flex items-center gap-3 min-w-0">
            <span className="w-10 h-10 rounded-full bg-[#0D6B6E] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
              {patientInitials}
            </span>
            <div className="min-w-0">
              <p className="font-semibold text-gray-900 mb-0 text-sm truncate">
                {patientFullName || "—"}
              </p>
              <p className="text-xs text-gray-500 mb-0">
                {[
                  patientAge != null ? `${patientAge} yrs` : null,
                  patientDetails.gender,
                  patientDetails.mobileNumber
                    ? `+91 ${patientDetails.mobileNumber}`
                    : null,
                ]
                  .filter(Boolean)
                  .join(" · ")}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 text-xs ml-auto">
            {appointmentId && (
              <span className="px-2.5 py-1 rounded-md bg-white border border-gray-200 text-gray-600 font-medium">
                Appt #{appointmentId}
              </span>
            )}
            {doctorName && (
              <span className="px-2.5 py-1 rounded-md bg-white border border-gray-200 text-gray-600 font-medium">
                Dr. {doctorName}
              </span>
            )}
          </div>
        </div>

        <div className="flex-1 overflow-y-auto min-h-0 px-5 py-5">
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#0D6B6E",
                borderRadius: 8,
                controlHeight: 40,
              },
            }}
          >
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              requiredMark={(label, { required }) =>
                required ? (
                  <>
                    {label} <span className="text-red-500">*</span>
                  </>
                ) : (
                  label
                )
              }
              className="surgery-enquiry-form"
            >
              <SectionTitle icon={User} title="Patient information" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mb-6">
            <Form.Item
              className={formItemClass}
              name="firstName"
              label="Name of patient"
              required
              initialValue={
                patientDetails.firstName && patientDetails.lastName
                  ? `${patientDetails.firstName} ${patientDetails.lastName}`
                  : ""
              }
            >
              <Input placeholder="Name" disabled />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="dob"
              label="Date of birth"
              required
              initialValue={
                patientDetails.dob ? moment(patientDetails.dob) : null
              }
            >
              <DatePicker
                placeholder="Please Select Your Date of Birth"
                format="MM/DD/YYYY"
                className="w-full"
                disabled
              />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="email"
              label="Email ID"
              rules={[
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="mobile"
              label="Phone number"
              required
              initialValue={patientDetails.mobileNumber}
            >
              <InputNumber
                name="mobile"
                placeholder="Phone Number"
                maxLength={10}
                className="w-full"
                disabled
              />
            </Form.Item>

            <Form.Item
              className={`${formItemClass} sm:col-span-2`}
              name="address1"
              label="Address"
              required
              initialValue={patientDetails.address}
              rules={[{ required: true, message: "Address is required" }]}
            >
              <Input placeholder="Address" />
            </Form.Item>

            <Form.Item
              className={`${formItemClass} sm:col-span-2`}
              name="address2"
              label="Address 2"
            >
              <Input placeholder="Address line 2" />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="pincode"
              label="Pin code"
              required
              rules={[
                { required: true, message: "Pincode is required" },
                { pattern: /^\d{6}$/, message: "Pincode must be exactly 6 digits" }
              ]}
            >
              <Input 
                placeholder="Pincode" 
                maxLength={6}
                value={pincode}
                onChange={handlePincodeChange}
                onKeyPress={(e) => {
                  // Prevent non-numeric input
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="state"
              label="State"
              required
              rules={[{ required: true, message: "State is required" }]}
            >
              <Select
                placeholder="Select State"
                showSearch
                options={stateOptions}
                filterOption={(input, option) =>
                  (option?.label || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(code) => {
                  const match = stateOptions.find((s) => s.value === code);
                  setFetchedState(match?.label || "");
                  lastFetchedCityStateRef.current = "";
                  fetchCitiesByStateCode(code);
                }}
              />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="city"
              label="City"
              required
              rules={[
                {
                  validator: async (_, value) => {
                    if (!selectedStateCode) {
                      return Promise.reject(new Error("Please select state first"));
                    }
                    if (!value) {
                      return Promise.reject(new Error("City is required"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                placeholder={
                  selectedStateCode ? "Select City" : "Select state first"
                }
                showSearch
                loading={cityLoading}
                disabled={!selectedStateCode}
                notFoundContent={
                  !selectedStateCode
                    ? "Select state first"
                    : cityLoading
                      ? "Loading cities..."
                      : "No cities found"
                }
                options={areaOptions}
                onChange={(city) => {
                  setFetchedCity(city || "");
                  getHospitalByCity(city);
                }}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>

            <Form.Item className={formItemClass} name="nationality" label="Nationality">
              <Select
                placeholder="Nationality"
                optionFilterProp="children"
                options={[
                  { value: "Indian", label: "Indian" },
                  { value: "Other", label: "Other" },
                ]}
              />
            </Form.Item>
              </div>

              <SectionTitle icon={ClipboardList} title="Surgery details" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mb-6">
            <Form.Item
              className={formItemClass}
              name="hospital"
              label="Select hospital"
              required
              rules={[
                {
                  validator: async (_, value) => {
                    if (!selectedStateCode) {
                      return Promise.reject(new Error("Please select state first"));
                    }
                    if (!selectedCityName) {
                      return Promise.reject(new Error("Please select city first"));
                    }
                    if (!value || value.length === 0) {
                      return Promise.reject(
                        new Error("Hospital selection is required")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder={
                  !selectedStateCode
                    ? "Select state first"
                    : !selectedCityName
                      ? "Select city first"
                      : "Select Hospitals"
                }
                showSearch
                disabled={!selectedCityName}
                notFoundContent={
                  !selectedStateCode
                    ? "Select state first"
                    : !selectedCityName
                      ? "Select city first"
                      : loading
                        ? "Loading hospitals..."
                        : "No hospitals found"
                }
                onChange={handleHospitalChange}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={hospitals.map((hospital) => ({
                  value: hospital.hospitalCode ,
                  label: hospital.hospitalName ,
                  key: hospital.hospitalCode,
                }))}
              />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="serviceType"
              label="Service type"
              required
              rules={[{ required: true, message: "Service Type is required" }]}
            >
              <Select
                placeholder="Service Type"
                optionFilterProp="children"
                onChange={handleServiceTypeChange}
                value={serviceTypenew}
              >
                <Select.Option value={8}>IPD</Select.Option>
                <Select.Option value={9}>OPD</Select.Option>
                <Select.Option value={10}>Investigation</Select.Option>
                <Select.Option value={11}>Day Care</Select.Option>
                <Select.Option value={12}>ICU</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="servicesubType"
              label="Service subtype"
              required
              rules={[
                { required: true, message: "Service Subtype is required" },
              ]}
            >
              <Select placeholder="Service Subtype" optionFilterProp="children">
                <Select.Option value={1}>Emergency</Select.Option>
                <Select.Option value={2}>Non-Emergency</Select.Option>
                <Select.Option value={3}>Others</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="HospitalizationType"
              label="Hospitalization type"
              required
              rules={[
                { required: true, message: "Hospitalization Type is required" },
              ]}
            >
              <Select
                placeholder="Hospitalization Type"
                optionFilterProp="children"
                onChange={handleHospitalizationTypeChange}
                value={hospitalizationtype}
                disabled={!serviceTypenew}
              >
                {renderHospitalizationOptions()}
              </Select>
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="procedureName"
              label="Hospitalization subtype"
              required
              rules={[
                {
                  required: true,
                  message: "Hospitalization Subtype is required",
                },
              ]}
            >
              <Select disabled={!hospitalizationtype}>
                <Select.Option>Select Hospitalization Subtype</Select.Option>
                {hospitalizationData &&
                  hospitalizationData.map((item) => (
                    <Select.Option
                      key={item.id}
                      value={item.hospitalizationSubTypeId}
                    >
                      {item.hospitalizationSubType}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="dateRange"
              className={`${formItemClass} sm:col-span-2`}
              label="Procedure planned dates"
              required
              rules={[
                { required: true, message: "Procedure dates are required" },
              ]}
            >
              <RangePicker className="w-full" format="DD/MM/YYYY" />
            </Form.Item>
              </div>

              <SectionTitle icon={FileText} title="Clinical information" />
              <div className="grid grid-cols-1 gap-y-1 mb-2">
            <Form.Item
              className={formItemClass}
              name="medicalcondition"
              label="Any other medical conditions?"
              initialValue={patientDetails.chiefComplaint}
            >
              <Input.TextArea
                rows={3}
                placeholder="Mention existing conditions, allergies..."
              />
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="uploadFile"
              label="Upload medical report"
            >
              <div className="border-2 border-dashed border-gray-200 rounded-xl p-5 text-center bg-gray-50/50 hover:border-[#0D6B6E]/40 transition-colors">
                <Upload
                  accept=".pdf, .png, .jpg, .jpeg,"
                  onChange={changeHandler}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />} className="border-[#0D6B6E] text-[#0D6B6E]">
                    Upload medical report
                  </Button>
                </Upload>
                {selectedreport && (
                  <p
                    className="text-sm font-semibold text-[#0D6B6E] mt-3 mb-0 cursor-pointer hover:underline"
                    onClick={openImageInNewTab}
                  >
                    {selectedreport}
                  </p>
                )}
              </div>
            </Form.Item>

            <Form.Item
              className={formItemClass}
              name="idproof"
              label="Upload prescription / referral letter"
            >
              <div className="border-2 border-dashed border-gray-200 rounded-xl p-5 text-center bg-gray-50/50 hover:border-[#0D6B6E]/40 transition-colors">
                <Upload
                  accept=".pdf, .png, .jpg, .jpeg,"
                  onChange={changeHandlernew}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />} className="border-[#0D6B6E] text-[#0D6B6E]">
                    Upload document
                  </Button>
                </Upload>
                {selectedIdreport && (
                  <p
                    className="text-sm font-semibold text-[#0D6B6E] mt-3 mb-0 cursor-pointer hover:underline"
                    onClick={openImageInNewTabidproof}
                  >
                    {selectedIdreport}
                  </p>
                )}
              </div>
            </Form.Item>
              </div>
            </Form>
          </ConfigProvider>
        </div>

        <div className="px-5 py-4 border-t border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 flex-shrink-0 bg-white">
          <p className="text-xs text-gray-500 mb-0">Fields marked * are required</p>
          <div className="flex items-center gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSave}
              disabled={saveLoading}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-gradient-to-r from-[#004172] to-[#3cba84] text-white text-sm font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saveLoading ? (
                <>
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Submitting...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4" />
                  Submit Enquiry
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
